import { render, staticRenderFns } from "./AddRelationGroup.vue?vue&type=template&id=242d5301"
import script from "./AddRelationGroup.vue?vue&type=script&lang=js"
export * from "./AddRelationGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports